import { Resource } from '../shared/resource';

export class JobEventFilter extends Resource {
  id: string;
  name: string;
  loading: boolean;
}
